import { Node, mergeAttributes } from "@tiptap/core";

export const GridBoxNode = Node.create({
  name: "gridBox",
  group: "block",
  content: "block*",
  defining: true,

  addAttributes() {
    return {
      style: {
        default: "display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;",
      },
      class: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (node) => {
          if (node instanceof HTMLElement && node.style.display === "grid") {
            return {
              style: node.getAttribute("style"),
              class: node.getAttribute("class"),
            };
          }
          return false;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), 0];
  },
});


